import React from "react";
import "./RatingBar.css";
export default function RatingBar({ label, score }) {
  return (
    <div className="rating-bar-container">
      <span className="highlighted-bar-text">
        {" "}
        <i
          class="fa-solid fa-circle-dot  fa-sm"
          style={{ color: "var(--dark-orange)" }}
        ></i>{" "}
        {label}
      </span>
      <div className="rating-bar">
        <div className="rating-bar-inner" style={{ width: score }}></div>
      </div>
    </div>
  );
}
